import styled from '@mint-lib/styled';

import Box from '../Box/Box.jsx';
import IconButton from '../IconButton/IconButton.jsx';

export const StyledFilterButtonContainer = styled(Box)({
  position: 'absolute',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
});

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  border: 'none',
  borderRight: `1px solid ${theme.palette.ui.tertiary}`,
  borderRadius: '4px 0px 0px 4px !important',
  height: '100%',
  width: '2.5rem',
  '&:hover': {
    backgroundColor: `${theme.palette.ui.hover} !important`,
  },
  '&:active': {
    backgroundColor: `${theme.palette.ui.active} !important`,
  },
  '&:focus': {
    boxShadow: 'none !important',
  },
}));
